import * as React from "react";
import "./index.css";
import Counter from "../../Button/Counter";
import SelectFileButton from "../../Button/SelectFileButton";
import { EditorState } from "draft-js";
import "draft-js/dist/Draft.css";
import DraftEditor from "../../DraftEditor";
import AdditionImagesModal from "../../Modals/AdditionImagesModal";

import { ReactSortable } from "react-sortablejs";
import { useJsApiLoader, StandaloneSearchBox } from "@react-google-maps/api";
import { Link } from "react-router-dom";
import { AddIcon, UploadIcon } from "../../icons";
import { useGetLocationsQuery } from "../../../features/supabase/usecase/locations";

const SubmitInformationForm = ({
  formState,
  onComplete,
  categories,
  amenities,
  facilities,
  formFiles,
  formAdditionalPictures,
  formAmenities,
  formFacilities,
  onDraftSave,
}) => {
  // console.log(categories, formAmenities, formFacilities, formFiles);
  const [state, setState] = React.useState({
    ...{
      category_id: categories[1].id,
      featured: false,
      address_fields: {},
      city: "",
    },
    ...formState,
  });

  const crossStreets = [
    'Eastern Parkway',
    'Union Street',
    'Carroll Street',
    'Crown Street',
    'Montgomery Street',
    'Empire Boulevard',
    'Lefferts Avenue',
    'East New York Avenue',
    'Maple Street',
    'Midwood Street',
    'Utica Avenue',
    'Schenectady Avenue',
    'Troy Avenue',
    'Albany Avenue',
    'Kingston Avenue',
    'Brooklyn Avenue',
    'New York Avenue',
    'Nostrand Avenue',
  ]

  const [selectedAmenities, setAmenities] = React.useState(formAmenities);

  const [additionalPictures, setAdditionalPictures] = React.useState(
    parseInt(formAdditionalPictures ?? 0)
  );

  const [selectedFacilities, setFacilities] = React.useState(formFacilities);

  const [isSubscribed, setIsSubscribed] = React.useState(true);

  const [files, setFiles] = React.useState(formFiles);

  const [formData, setFormData] = React.useState({});

  const pricingSchedules = ["Per Year", "Per Month", "Per Week", "Per Night"];

  const inputRef = React.useRef(null);

  const { data: locations, error, isLoading } = useGetLocationsQuery({ categoryId: parseInt(state.category_id) });

  const category = React.useMemo(() => {
    const result = categories.find((e) => e.id === parseInt(state.category_id));
    return result;
  }, [state.category_id]);

  const filterLocations = React.useMemo(() => {
    return (locations || []).filter((val) => val.id === parseInt(state.location_id || "0"));
  }, [locations, state]);

  const isJobApplication = React.useMemo(
    () => {
      return category.type === "job"
    },
    [category]
  );


  const onSubmit = (e) => {
    e.preventDefault();
    if (state.email === "" || state.phone === "") {
      alert("Please fill in the email and phone number fields");
      return;
    }
    if (files.length <= 5 && additionalPictures === 1) {
      onComplete({
        state,
        files,
        selectedAmenities,
        selectedFacilities,
        additionalPictures: 0,
      });
    } else {
      onComplete({
        state,
        files,
        selectedAmenities,
        selectedFacilities,
        additionalPictures,
      });
    }
  };

  const onDraft = (e) => {
    e.preventDefault();
    onDraftSave({ state, files, selectedAmenities, selectedFacilities });
  };

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyA3l-W7zveLhLhT79IdxEaeGmsCE0xJgF8",
    libraries: ["places"],
    nonce: "codedecoders",
  });

  React.useEffect(() => {
    if (!formState?.id) {
      var expTime = localStorage.getItem("duration");
      if (expTime && new Date().getTime() < parseInt(expTime)) {
        localStorage.getItem("classified") &&
          setState(JSON.parse(localStorage.getItem("classified")));
        localStorage.getItem("amenities") &&
          setAmenities(JSON.parse(localStorage.getItem("amenities")));
        localStorage.getItem("facilities") &&
          setFacilities(JSON.parse(localStorage.getItem("facilities")));
      } else {
        localStorage.removeItem("classified");
        localStorage.removeItem("amenities");
        localStorage.removeItem("facilities");
        localStorage.removeItem("duration");
      }
    }
  }, []);

  React.useEffect(() => {
    if (localStorage.getItem("duration") === null)
      localStorage.setItem(
        "duration",
        new Date().getTime() + 1000 * 60 * 60 * 24
      );
  }, []);

  React.useEffect(() => {
    if (!state?.id) {
      localStorage.setItem("classified", JSON.stringify(state));
      localStorage.setItem("amenities", JSON.stringify(selectedAmenities));
      localStorage.setItem("facilities", JSON.stringify(selectedFacilities));
    }
  }, [state, selectedAmenities, selectedFacilities, files, formData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: name === "city" && value === "" ? null : value,
    }));
  };

  const handleStateChange = ({ key, value }) => {
    setState((val) => ({
      ...val,
      [key]: value,
    }));
  };

  const handleAddressField = (e) => {
    setState((val) => ({
      ...val,
      address_fields: {
        ...val.address_fields,
        [e.target.name]: e.target.value,
      },
    }));
  };

  const handleFaculityChange = ({ key, value }) => {
    setFacilities((val) => ({
      ...val,
      [key]: value,
    }));
  };

  const handleAmenityChange = (key) => {
    setAmenities((val) => ({
      ...val,
      [key]: !val[key],
    }));
  };

  const handlePlacesChanged = () => {
    const places = inputRef.current.getPlaces();

    if (places && places.length > 0) {
      const place = places[0];
      const addressComponents = place.address_components;

      const countryComponent = addressComponents.find((component) =>
        component.types.includes("country")
      );
      const streetComponent = addressComponents.find((component) =>
        component.types.includes("route")
      );
      const apartmentComponent = addressComponents.find((component) =>
        component.types.includes("street_number")
      );
      const cityComponent =
        addressComponents.find((component) =>
          component.types.includes("locality")
        ) ||
        addressComponents.find((component) =>
          component.types.includes("sublocality")
        );
      const stateComponent = addressComponents.find((component) =>
        component.types.includes("administrative_area_level_1")
      );
      const postalCodeComponent = addressComponents.find((component) =>
        component.types.includes("postal_code")
      );

      const address = place.formatted_address;
      const country = countryComponent ? countryComponent.long_name : "";
      const streetAddress = streetComponent ? streetComponent.long_name : "";
      const apartment = apartmentComponent ? apartmentComponent.long_name : "";
      const city = cityComponent ? cityComponent.long_name : "";
      const state = stateComponent ? stateComponent.long_name : "";
      const postalCode = postalCodeComponent
        ? postalCodeComponent.long_name
        : "";

      setFormData({
        ...formData,
        address,
        country,
        streetAddress,
        apartment,
        city,
        state,
        postalCode,
      });
      console.log(places);
    } else {
      console.log("No places found or the API did not return any results.");
    }
  };

  React.useEffect(() => {
    if (formData) {
      setState((val) => ({
        ...val,
        address_fields: {
          ...val.address_fields,
          ...formData,
        },
      }));
    }
  }, [formData]);

  return (
    <form
      onSubmit={onSubmit}
      onKeyDown={(event) => {
        // Check if the pressed key is Enter and if the target is an input element
        if (event.key === "Enter" && event.target.tagName === "INPUT") {
          event.preventDefault(); // Prevent form submission on Enter key
        }
      }}
      className="submit-info-page"
    >
      <div className="form-field">
        <span className="form-header">Select a Category<sup>*</sup></span>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <select
            name="category_id"
            onChange={(e) => {
              handleStateChange({
                key: e.target.name,
                value: parseInt(e.target.value),
              });
            }}
            value={state.category_id}
            required
          >
            {categories.map((e, i) => {
              return (
                <option value={e.id}>
                  {e.name}
                </option>
              );
            })}
          </select>
          <span style={{ fontSize: "20px", fontWeight: "bold" }}>
            {
              categories.find((e) => e.id === parseInt(state.category_id))?.price !== 0 ? `Price: \$${categories.find((e) => e.id === parseInt(state.category_id))?.price}` : 'Price: FREE'
            }
          </span>
        </div>
      </div>
      <div className="form-field">
        <span className="form-header">
          Title<sup>*</sup>
        </span>
        <span className="form-subheader" style={{
          color: 'gray'
        }}>Title limit 65 characters</span>
        <input
          placeholder="Write your title here"
          name="title"
          onChange={handleInputChange}
          value={state.title}
          minLength={10}
          maxLength={65}
          required
        />
        <div className="title-counter">{state?.title?.length ?? 0}/65 characters used</div>
      </div>
      {category.type !== "others" && (
        <>
          <div className="form-field">
            <span className="form-header">Choose a Location <span> (optional)</span></span>
            <select
              name="location_id"
              onChange={handleInputChange}
              value={state.location_id}
            >
              <option value="">
                {"Select location"}
              </option>
              {(locations || []).map((location, i) => {
                return <option value={location.id}>{location.location}</option>;
              })}
            </select>
          </div>
          {state.location_id !== "" && category.type !== "job" && (
            <div className="form-field">
              <span className="form-header">Address  <span> (optional)</span></span>
              {isLoaded && (
                <StandaloneSearchBox
                  onLoad={(ref) => (inputRef.current = ref)}
                  onPlacesChanged={handlePlacesChanged}
                >
                  <input
                    type="text"
                    name="address"
                    value={state.address_fields?.address ?? ""}
                    onChange={handleAddressField}
                    tabIndex={0}
                    style={{ width: "calc(100% - 35px)" }}
                    placeholder="Enter your address"
                    onBlur={() => {
                      if (!formData?.address_fields?.address) {
                        console.log("address not found");
                        setState((prevState) => ({
                          ...prevState,
                          address_fields: {
                            ...prevState.address_fields,
                            address: "",
                          },
                        }));
                      }
                    }}
                  />
                </StandaloneSearchBox>
              )}
            </div>
          )}
        </>
      )}
      {filterLocations.length > 0 && filterLocations[0].location === "Crown Heights" && category.type !== "others" && (
        <div className="form-field">
          <span className="form-header">Cross Streets  <span> (optional)</span></span>
          <div className="address-row column">
            <select className="address-field" name={"cross_street1"} value={state?.address_fields?.cross_street1 ?? ""} onChange={handleAddressField}>
              <option value="">Select Cross Street</option>
              {crossStreets.map((street, i) => {
                return <option value={street}>{street}</option>;
              })}
            </select>
            {/* <input
              placeholder="Crown"
              className="address-field"
              name={"cross_street1"}
              value={state?.address_fields?.cross_street1 ?? ""}
              onChange={handleAddressField}
            /> */}
            <div>Between</div>
            <select className="address-field" name={"cross_street2"} value={state?.address_fields?.cross_street2 ?? ""} onChange={handleAddressField}>
              <option value="">Select Cross Street</option>
              {crossStreets.map((street, i) => {
                return <option value={street}>{street}</option>;
              })}
            </select>
            {/* <input
              placeholder="Kingston"
              className="address-field"
              name={"cross_street2"}
              value={state?.address_fields?.cross_street2 ?? ""}
              onChange={handleAddressField}
            /> */}
            <div>And</div>
            <select className="address-field" name={"cross_street3"} value={state?.address_fields?.cross_street3 ?? ""} onChange={handleAddressField}>
              <option value="">Select Cross Street</option>
              {crossStreets.map((street, i) => {
                return <option value={street}>{street}</option>;
              })}
            </select>
            {/* <input
              placeholder="Brooklyn"
              className="address-field"
              name={"cross_street3"}
              value={state?.address_fields?.cross_street3 ?? ""}
              onChange={handleAddressField}
            /> */}
          </div>
        </div>
      )}
      {
        isJobApplication && (
          <div className="form-field-row">
            <div className="form-field">
              <span className="form-header">
                Salary
                <span> (optional)</span>
              </span>
              <input
                placeholder="65K-80K"
                name={"salary"}
                type="number"
                value={state.salary}
                onChange={handleInputChange}
              />
            </div>
          </div>
        )
      }
      {category.type !== "others" && !isJobApplication && (
        <div className="form-field location">
          <span className="form-header">Location info  <span> (optional)</span></span>
          <div>
            {facilities.map((facility, i) => {
              if (facility.id === 3 && state.category_id !== 3) {
                return null;
              }
              return (
                <div className="location-info">
                  <span>{facility.name}</span>
                  <Counter
                    key={i}
                    value={selectedFacilities[facility.id] ?? 0}
                    onChange={(val) =>
                      handleFaculityChange({
                        key: facility.id,
                        value: val,
                      })
                    }
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
      {category.type !== "others" && !isJobApplication && (
        <div className="form-field">
          <div>
            <span className="form-header">Amenities  <span> (optional)</span></span>
            <div className="amenities-description">
              Please select those that apply
            </div>
          </div>
          <div className="amenities">
            {amenities.map((amenity, i) => {
              return (
                <div
                  className={`amenity ${selectedAmenities[amenity.id] ?? false ? "active" : ""
                    }`}
                  key={i}
                  onClick={() => handleAmenityChange(amenity.id)}
                >
                  <img
                    src={require(`../../../images/${amenity.icon}`)}
                    alt={amenity.name}
                    className="amenity-image"
                  />
                  <div className="amenity-title">{amenity.name}</div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {category.type !== "others" && !isJobApplication && (
        <div className="form-field">
          <span className="form-header">Location Sqft.  <span> (optional)</span></span>
          <div className="sqft">
            <input
              name={"location_sqft"}
              placeholder={"eg: 4,500"}
              type={"text"}
              className="max-size-field"
              onChange={handleInputChange}
              value={state.location_sqft}
            />
            <span>
              <input
                type="checkbox"
                name="newly_renovated"
                onChange={(e) =>
                  handleStateChange(e.target.name, e.target.checked)
                }
                value={state.newly_renovated}
                id="newly_renovated"
              />
              <label for="newly_renovated">Newly Renovated</label>
            </span>
          </div>
        </div>
      )}
      {
        isJobApplication ? <div className="form-field input">
          <span className="form-header">Add a Company Logo/Image  <span> (optional)</span></span>
          {files.length > 0 ? (
            <SelectFileButton
              name={"companyImage"}
              file={files.length > 0 && files[0]}
              props={{
                single: true,
              }}
              onFileDelete={() => {
                setFiles((val) => []);
              }}
              setFile={(e) => {
                setFiles((val) => {
                  return [
                    {
                      ...val[0],
                      file: e,
                    },
                  ];
                });
              }}
            />
          ) : (
            <SelectFileButton
              setFile={(e) => {
                setFiles((val) => {
                  if (val.length > 0) {
                    return [
                      {
                        ...val[0],
                        file: e[0],
                      },
                    ];
                  } else {
                    return [{ file: e[0] }];
                  }
                });
              }}
              label={"add"}
            />
          )}
        </div> :
          <div className="form-field">
            <div className="form-header">
              Add a Photo  <span> (optional)</span>
              <br />
              <span>Drag & Drop to Upload and Re-order Images</span>
            </div>
            {files.length === 0 ?
              <label htmlFor="images" className="drag-drop-container"
                onDragOver={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onDragEnter={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}

                onDrop={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setFiles((val) => [
                    ...val,
                    ...Array.from(e.dataTransfer.files).map((e) => ({ file: e })),
                  ]);
                }
                }
              >
                <input type="file" id="images" multiple onChange={(e) => {
                  setFiles((val) => [
                    ...val,
                    ...Array.from(e.target.files).map((e) => ({ file: e })),
                  ]);
                }} />
                <UploadIcon stroke={'grey'} />
                <div><b>Click to upload</b> or drag and drop</div>
                <div>PNG, JPG or JPEG files only</div>
              </label>
              : <ReactSortable
                list={files}
                setList={setFiles}
                filter={".add"}
                delayOnTouchOnly
                delay={200}
                swapThreshold={1}
                animation={150}
                className="image-grid"
              >
                {files.map((e, index) => (
                  <SelectFileButton
                    key={index}
                    file={e}
                    onFileDelete={() => {
                      setFiles((val) => val.filter((_, i) => i !== index));
                    }}
                    setFile={(file) => {
                      setFiles((val) =>
                        val.map((e, i) => {
                          if (i === index) {
                            return {
                              ...e,
                              file,
                            };
                          } else {
                            return e;
                          }
                        })
                      );
                    }}
                    label={index == 0}
                  />
                ))}
                <SelectFileButton
                  setFile={(e) => {
                    if (additionalPictures === 0 && files.length >= 5) {
                      setIsSubscribed(true);
                      return;
                    }
                    setFiles((val) => [
                      ...val,
                      ...Array.from(e).map((e) => ({ file: e })),
                    ]);
                  }}
                  label={"add"}
                />
              </ReactSortable>}
          </div>
      }
      {category.type !== "others" && !isJobApplication && (
        <div className="form-field">
          <span className="form-header">Pricing  <span> (optional)</span></span>
          <div className="form-field-row column">
            <input
              name={"price"}
              placeholder={"$"}
              type="number"
              min={0}
              className="max-size-field"
              onChange={handleInputChange}
              value={state.price}
            />
            {category.name !== "For Sale" && (
              <select
                name="price_type"
                value={state?.price_type}
                onChange={handleInputChange}
                className="schedule-field"
              >
                <option selected disabled>
                  Price Schedule
                </option>
                {pricingSchedules
                  .filter((e) => {
                    // if category is short term then remove the for year option
                    return category === "Short Term"
                      ? e !== "Per Year"
                      : true;
                  })
                  .map((e, i) => {
                    return <option value={e}>{e}</option>;
                  })}
              </select>
            )}
            {category.name === "Short Term Rent" && (
              <input
                name={"min_nights"}
                placeholder={"Minimum Nights"}
                type="number"
                min={0}
                className="max-size-field"
                onChange={handleInputChange}
                value={state.min_nights}
              />
            )}
          </div>
        </div>
      )}
      <div className="form-field description">
        <span className="form-header">Description  <span> (optional)</span></span>
        <DraftEditor
          key={1}
          category={category.name}
          onChange={(e) => {
            console.log(decodeURI(e));
            handleStateChange({ key: "description", value: decodeURI(e) });
          }}
          state={formState?.description ?? ""}
        />
      </div>
      <div className="form-header">Contact Information</div>
      <div className="form-field">
        <div className="form-field-row column">
          <div className="form-field">
            <span className="form-subheader">
              Email<sup>*</sup>
            </span>
            <input
              name={"email"}
              placeholder="Type your email address"
              type="email"
              onChange={handleInputChange}
              value={state.email}
              required
            />
          </div>
          <div className="form-field">
            <span className="form-subheader">
              Phone Number<sup>*</sup>
            </span>
            <input
              name={"phone"}
              placeholder="(XXX) XXX-XXXX"
              onChange={(e) => {
                handleInputChange(e);
              }}
              type="tel"
              value={state.phone}
              minLength={10}
              maxLength={10}
              required
            />
          </div>
        </div>
        <div className="form-field-row column">
          <div className="form-field">
            <span className="form-subheader">WhatsApp</span>
            <input
              key={state.phone}
              name={"whatsapp"}
              placeholder="(XXX) XXX-XXXX"
              onChange={handleInputChange}
              type="tel"
              value={state.whatsapp}
              disabled={state["same as phone"]}
              minLength={10}
              maxLength={10}
            />
            <div style={{ display: "flex", alignItems: "center" }}>
              <input
                type="checkbox"
                name="same as phone"
                onChange={(e) => {
                  if (e.target.checked)
                    handleStateChange({ key: "whatsapp", value: state.phone });
                  else handleStateChange({ key: "whatsapp", value: "" });
                  handleStateChange({
                    key: e.target.name,
                    value: e.target.checked,
                  });
                }}
                value={state["same as phone"]}
                id="same as phone"
              />
              <label htmlFor="same as phone">Same as Phone</label>
            </div>
          </div>
          <div className="form-field disabled">
            <span className="form-subheader">
              WhatsApp<sup>*</sup>
            </span>
            <input name={"number"} placeholder="(XXX) XXX-XXXX" />
          </div>
        </div>
        <div className={`submit-information-footer form-page-footer`}>
          <button type="button" className={`btn-as-left`} onClick={onDraft}>
            Save as Draft
          </button>
          <button type="submit" className={`btn-as-right active`}>
            Save & Continue
          </button>
        </div>
      </div>
      {additionalPictures !== 1 && files.length >= 5 && isSubscribed && (
        <AdditionImagesModal
          onUpgrade={() => {
            setAdditionalPictures((val) => 1);
          }}
          onClose={() => {
            setIsSubscribed(false);
            if (files.length > 5 + additionalPictures * 10) {
              setFiles((val) => val.slice(0, 5 + additionalPictures * 10));
            }
          }}
          files={files}
        />
      )}
    </form>
  );
};

export default SubmitInformationForm;
